const features = [
  {
    icon: 'ri-flashlight-line',
    title: '独家一手内幕',
    desc: '网红吃瓜吃料网每日爆料，我们拥有遍布娱乐圈的线人网络，为您带来最前沿的国产51精品入口吃瓜爆料与网红最新爆料。',
    color: 'text-primary-600 bg-primary-100',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '极速更新追踪',
    desc: '7×24小时不间断监控娱乐圈动态，从事件发生到吃瓜爆料每日更新，最快只需15分钟。热门事件实时追踪，绝不错过。',
    color: 'text-accent-600 bg-accent-100',
  },
  {
    icon: 'ri-shield-check-line',
    title: '信息交叉验证',
    desc: '每一条精品吃瓜内幕都经过多渠道交叉验证，标注信息可信度等级。拒绝虚假谣言，只做有料有据的真瓜。',
    color: 'text-secondary-600 bg-secondary-100',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-2">本站特色</h2>
        <p className="text-sm text-foreground-500 mb-8">为什么选择吃瓜网站？三个核心优势告诉你</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((feat, idx) => (
            <div key={idx} className="p-6 rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-200/60 transition-colors group">
              <span className={`w-12 h-12 flex items-center justify-center rounded-xl ${feat.color} mb-4`}>
                <i className={`${feat.icon} text-xl`}></i>
              </span>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}